import React from "react";
import Herosection from "../components/landingpage/Herosection";
// import Services from "../components/landingpage/Services";
import Servicesnew from "../components/landingpage/Servicesnew";
import Publishingsolution from "../components/landingpage/Publishingsolution";
// import Ourapproach from "../components/landingpage/Ourapproach";
import ClientCarousel from "../components/landingpage/ClientCarousel";
// import Highlights from "../components/landingpage/Highlights";
import data from "../json/landingpage/Clientcarousel.json";
// import OurExpertService from "../components/landingpage/OurExpertService";
import Highlightsnew from "../components/landingpage/Highlightsnew";
import { BusinessTarget } from "../components/landingpage/BusinessTarget";
import SEO from "../components/SEO";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Transforma Pvt Ltd",
  url: "https://www.transforma.in",
  logo: "https://www.transforma.in/images/transformalogo.svg",
};

const Landingpage = ({ bannerValid, showBanner, setShowBanner }) => {
  return (
  <>
     <SEO
        title="World's Best Cost Effective Publishing Service Provider"
        metatitle="Transforma Pvt Ltd | e-Publishing & IT Services"
        description="Most cost-effective publishing services through technology-enabled processes for books, journals, and magazines, with MRW streamlining editing and peer review."
        keywords="e-Publishing, content transformation, STM books, scholarly publishing, LaTeX, QuarkXPress, InDesign, 3B2, FrameMaker, IT services, software solutions, digital publishing, workflow automation, XML, content management, publishing technology Content Digitization, Content Conversion, Project Management"
        canonical="https://www.transforma.in"
        schema={organizationSchema}
      />
    <div role="main" className="w-full flex flex-col items-center ruler">
      <Herosection
        bannerValid={bannerValid}
        showBanner={showBanner}
        setShowBanner={setShowBanner}
      />
      {/* <Services /> */}
      <Servicesnew />
      {/* <Ourapproach /> */}
      <Publishingsolution />
      {/* Businesstarget */}
      <BusinessTarget />
      {/* <Highlights /> */}
      <Highlightsnew />
      <ClientCarousel data={data} />
    </div>
    </>
  );
};

export default Landingpage;
